function blockedUser(state) {
  return {
    loading: state.blockedUserReducer.loading,
    error: state.blockedUserReducer.error,
    userStatus: state.blockedUserReducer.userStatus,
    blockedUserMessageKey: state.blockedUserReducer.blockedUserMessageKey
  };
}

export { blockedUser };
